var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 53,
    fill: "none",
    viewBox: "0 0 48 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7199FF",
    d: "M12.866 48h18.268C38.24 48 44 42.278 44 35.22V17.78C44 10.722 38.24 5 31.134 5H12.866C5.76 5 0 10.722 0 17.78v17.44C0 42.277 5.76 48 12.866 48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.519 43.027h13.515a9.519 9.519 0 0 0 9.52-9.52V20.52A9.519 9.519 0 0 0 29.033 11H15.52A9.519 9.519 0 0 0 6 20.519v12.989a9.519 9.519 0 0 0 9.519 9.519Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7199FF",
    d: "M19.34 20.454V35h-3.076V20.454h3.076ZM21.87 35V20.454h9.63v2.536h-6.555v3.466h5.916v2.535h-5.916V35H21.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e9502935431155cbd93a6bc99c19b70.svg";
export { ForwardRef as ReactComponent };